export default "__VITE_PUBLIC_ASSET__f903ad0e__"